import type { ConciseWorkspace } from '@festina/configuration-general-types/configuration'
import { configurationKeys, type WorkspaceKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { useAvailableServersForConfiguration } from '../system/useAvailableServersForConfiguration'

export const useRevalidateWorkspace = (
  getWorkspace: (key: Optional<WorkspaceKey>) => Optional<ConciseWorkspace>,
) => {
  const allServers = useAvailableServersForConfiguration()
  const queryClient = useQueryClient()

  return useCallback(
    (workspaceKey: WorkspaceKey) => {
      const workspace = getWorkspace(workspaceKey)
      if (workspace) {
        void queryClient.invalidateQueries({
          queryKey: configurationKeys.fetchAllConciseWorkspacesKey(allServers),
        })

        void queryClient.invalidateQueries({
          queryKey: configurationKeys.fetchConciseBranchKeyPrefix({
            server: workspaceKey.branchKey.server,
            branchName: workspace.baseBranchName,
          }),
        })

        void queryClient.invalidateQueries({
          queryKey: configurationKeys.fetchConciseWorkspaceKeyPrefix({
            server: workspaceKey.branchKey.server,
            workspaceName: workspaceKey.name,
          }),
        })

        void queryClient.invalidateQueries({
          queryKey: configurationKeys.fetchWorkspaceAllErrorsKeyPrefix({
            server: workspaceKey.branchKey.server,
            workspaceName: workspaceKey.name,
          }),
        })
      }
    },
    [getWorkspace, queryClient, allServers],
  )
}
